import * as React from 'react'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import CardMedia from '@mui/material/CardMedia'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import Avatar from '@mui/material/Avatar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  // faConciergeBell,
  faMapMarkedAlt,
} from '@fortawesome/free-solid-svg-icons'

import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import RatingBar from '../../components/RatingBar'
import './restaurantcomponent.css'

const RestaurantComponent = ({
  banner,
  retaurantName,
  mapView,
  image,
  opened,
  open_status,
  restaurant,
  restaurantsingle,
  setSelectedRestaurant,
}) => {
  return (
    <div className={'div_restaurant_card'}>
      <Card
        sx={{
          maxWidth: 240,
          maxHeight: 270,
          border: opened === 1 ? '1px solid green' : '1px solid red',
        }}
        className="m-1"
      >
        {restaurantsingle.restaurant.discount > 0 ? (
          <div
            style={{
              height: 25,
              // width: 180,
              backgroundColor: 'green',
              position: 'absolute',
              // marginTop: 5,
              // borderTopRightRadius: 50,
              borderBottomRightRadius: 25,
              // padding: 1.7,
            }}
          >
            <p
              style={{
                color: 'white',
                fontSize: 12,
                marginRight: 3,
                paddingRight: 7,
              }}
            >
              Discount Of {restaurantsingle?.restaurant?.discount ?? 0}% at
              checkout
            </p>
          </div>
        ) : (
          ''
        )}
        <CardMedia
          style={{
            backgroundSize: 'center',
            backgroundPosition: 'center',
          }}
          component="img"
          height="80"
          image={banner}
          className="restaurantImage"
          alt="Paella dish"
        />
        <CardContent>
          <Typography className="restaurantLoc">
            <FontAwesomeIcon icon={faMapMarkedAlt} />{' '}
            <span className="ml-2">{restaurant.city}</span>
          </Typography>
          {/* <div
            className="restaurantLoc"
            style={{ height: '20px', overflow: 'hidden' }}
          >
            <p className="foodItems mb-3">
              <span>
                <FontAwesomeIcon icon={faConciergeBell} className="mr-2" />{' '}
              </span>
              {restaurantsingle.meals.length > 0 ? (
                restaurantsingle.meals.map((meals, index) => (
                  <span key={index}>{meals.meal} &#8226; </span>
                ))
              ) : (
                <span className="foodItems">No meal available</span>
              )}
            </p>
          </div> */}
        </CardContent>
        <CardActions disableSpacing sx={{ height: 5 }}>
          <Typography variant="body2" color="text.secondary">
            <RatingBar rating={restaurant.rating} />
          </Typography>
          {/* {opened === 1 ?
                        <span className="badge badge-success m-0 ml-2" title={`Mon-Fri: ${restaurant.mffrom}-${restaurant.mfto}
                        Sat: ${restaurant.safrom}-${restaurant.sato}
                        Sun: ${restaurant.sufrom}-${restaurant.suto}`
                        }
                            style={{ verticalAlign: 'text-bottom' }}>
                            Opened
                        </span> :
                        <span className="badge badge-danger m-0 ml-2" title={`Mon-Fri: ${restaurant.mffrom}-${restaurant.mfto}
                        Sat: ${restaurant.safrom}-${restaurant.sato}
                        Sun: ${restaurant.sufrom}-${restaurant.suto}`
                        }
                            style={{ verticalAlign: 'text-bottom' }}>
                            Closed
                        </span>
                    }
                    {
                        opened === 0 ? <span className="badge badge-danger m-0 ml-2">Unavailable For Orders</span> :
                            open_status === "open"
                                ?
                                <span className="badge badge-success m-0 ml-2">Available For Orders</span>
                                : <span className="badge badge-danger m-0 ml-2">Unavailable For Orders</span>
                    } */}
        </CardActions>
        <CardHeader
          avatar={<Avatar alt={retaurantName} src={image} />}
          title={retaurantName}
          subheader=""
          action={
            mapView ? (
              <IconButton
                aria-label="Meals"
                onClick={() => setSelectedRestaurant(restaurantsingle)}
              >
                <OpenInNewIcon />
              </IconButton>
            ) : (
              ''
            )
          }
        />
        {restaurantsingle.restaurant.hosting_fee > 0 ? (
          <div
            style={{
              height: 25,
              width: 180,
              backgroundColor: 'green',
              borderTopRightRadius: 20,
              // borderBottomRightRadius: 50,
            }}
          >
            <p
              style={{
                color: 'white',
                fontSize: 12,
                marginRight: 3,
                paddingRight: 7,
              }}
            >
              Hosting Fee JMD ${restaurantsingle?.restaurant?.hosting_fee ?? 0}
            </p>
          </div>
        ) : (
          ''
        )}
      </Card>
    </div>
  )
}

export default RestaurantComponent
